import { render, staticRenderFns } from "./SessionDetailQuestion.vue?vue&type=template&id=61ce50d9&scoped=true&"
import script from "./SessionDetailQuestion.vue?vue&type=script&lang=js&"
export * from "./SessionDetailQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailQuestion.vue?vue&type=style&index=0&id=61ce50d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ce50d9",
  null
  
)

export default component.exports